import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { GERENCIA_ABASTECIMENTO } from '~/constants/modules';
import { t, can } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteCentroCusto,
  findCentroCusto,
  recordFiltering,
} from '~/store/modules/centrocusto/actions';

import Form from './form';

function CentroCustoList() {
  const redux = useSelector((state) => state.centrocusto);

  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const header = React.useMemo(() => {
    const items = [
      {
        id: 'idcentrocusto',
        label: t('s.cadastro.centrocusto.idcentrocusto'),
        filter: { type: 'text' },
      },
      {
        id: 'nomecentrocusto',
        label: t('s.cadastro.centrocusto.nomecentrocusto'),
        filter: { type: 'text' },
      },
      {
        id: 'statuscentrocusto',
        label: t('s.cadastro.centrocusto.statuscentrocusto'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ];

    if (can(GERENCIA_ABASTECIMENTO))
      items.splice(2, 0, {
        id: 'nomegerencia',
        label: t('s.cadastro.centrocusto.nomegerencia'),
        filter: { type: 'text' },
      });

    return items;
  }, [status]);

  // imprime em pdf ou xls

  const fieldlist = ['idcentrocusto', 'nomecentrocusto'];

  if (can(GERENCIA_ABASTECIMENTO)) {
    fieldlist.push('nomegerencia');
  }

  fieldlist.push('statuscentrocusto');

  const substituirHeader = {
    idcentrocusto: t('s.cadastro.centrocusto.idcentrocusto'),
    nomecentrocusto: t('s.cadastro.centrocusto.nomecentrocusto'),
    nomegerencia: t('s.cadastro.centrocusto.nomegerencia'),
    statuscentrocusto: t('s.cadastro.centrocusto.statuscentrocusto'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findCentroCusto}
      remove={deleteCentroCusto}
      form={Form}
      keys="idcentrocusto"
      detach="idcentrocusto"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'centroscustos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Centros de Custo',
          substituirValores: {
            statuscentrocusto: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
            },
          },
        })
      }
    />
  );
}

export default CentroCustoList;
